import React from 'react';
import HairCutTable from './components/HariCutTable.component';
import PositionsTable from './components/PositionsTable.component';
import StressTestTable from './components/StressTestTable.component';
import { Grid } from '@mui/material';
import NoDataMessage from '../../../feedback/NoDataMessage.component';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import { useCollateralStressTestPageQuery } from '../../../../api/rs-hg/risk/hooks/queries';
import {
  resolveCollateralPortfolioPayload,
  type CollateralStressTestPageModel,
} from '../../../../api/rs-hg/risk/collateralStressTest.types';

const CollateralMonitor: React.FC<FundInfoComponentProps> = ({ fundId, positionDate = '' }) => {

  const isPositionDateLoading = !!fundId && !positionDate;

  const collateralQuery = useCollateralStressTestPageQuery(fundId, positionDate);

  return (
    <QueryBoundary<CollateralStressTestPageModel>
      isLoading={isPositionDateLoading || collateralQuery.isLoading}
      isFetching={collateralQuery.isFetching}
      isError={collateralQuery.isError}
      error={collateralQuery.error}
      data={
        collateralQuery.data &&
          resolveCollateralPortfolioPayload(collateralQuery.data)
          ? collateralQuery.data
          : null
      }
      loadingMessages={['Loading Collateral Monitor Data', '...']}
      errorMessage="Unable to load collateral monitor data."
      noDataMessage="No collateral monitor data available."
    >
      {(pageModel) => {
        const payload = resolveCollateralPortfolioPayload(pageModel)!;

        return (
          <Grid container spacing={2} style={{ padding: 8 }}>
            <StressTestTable payload={payload} />
            <HairCutTable payload={payload} />
            <PositionsTable payload={payload} />
          </Grid>
        );
      }}
    </QueryBoundary>
  );
};

export default CollateralMonitor;
